import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import SchemaOrg from "./schema-org"
import checkTokenSlashes from "../../helpers/checkTokenSlashes"

function SEO({ lang, metadata, seo_data, location }) {
  seo_data = JSON.parse(seo_data)

  let { name, title, description, page_visible } = seo_data
  // If frontmatter fields empty, set to token values
  let metaTitle = ""
  title && title !== "" && title !== "null"
    ? (metaTitle = title)
    : (metaTitle = metadata.CompanyName)
  let metaName = name || metaTitle
  let metaDescription = description || metadata.CompanySlogan

  let baseURL = ""
  baseURL = checkTokenSlashes(metadata.SiteURL, "end")
  let metaURL = ""
  if (location && location.pathname) {
    metaURL = location.pathname
  }

  let robotsMeta = "index"
  page_visible ? (robotsMeta = "index") : (robotsMeta = "noindex")

  let isBlogPost = false
  seo_data.isBlogPost ? (isBlogPost = true) : (isBlogPost = false)

  let datePublished
  if (seo_data.datePublished) {
    datePublished = seo_data.datePublished
  } else {
    datePublished = ""
  }

  let metaAuthor
  if (isBlogPost && seo_data.author) {
    metaAuthor = seo_data.author
  } else {
    metaAuthor = metadata.CompanyName
  }

  let socialCard = checkTokenSlashes(metadata.SocialCard, "start")
  let metaImage
  if (isBlogPost && seo_data.featuredImage) {
    metaImage = `${baseURL}${seo_data.featuredImage}`
  } else {
    metaImage = `${baseURL}${socialCard}`
  }

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={metaTitle}
        titleTemplate={metaTitle}
      >
        <meta name={`robots`} content={robotsMeta} />
        <meta name={`description`} content={metaDescription} />
        <meta
          name={`viewport`}
          content={`width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no`}
        />
        <meta name={`og:title`} content={metaTitle} />
        <meta name={`og:description`} content={metaDescription} />
        <meta name={`og:image`} content={metaImage} />
        <meta name={`og:url`} content={`${baseURL}${metaURL}`} />
        <meta name={`og:type`} content={`website`} />
      </Helmet>
      <SchemaOrg
        url={`${baseURL}${metaURL}`}
        title={metaName}
        defaultTitle={metaName}
        isBlogPost={isBlogPost}
        image={metaImage}
        description={metaDescription}
        datePublished={datePublished}
        canonicalUrl={`${baseURL}${metaURL}`}
        author={metaAuthor}
        organization={metadata.CompanyName}
      />
    </>
  )
}

SEO.defaultProps = {
  lang: `en`,
  seo_data: {},
}

SEO.propTypes = {
  lang: PropTypes.string,
}

export default SEO
